import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";
import { Currency } from '../../../base/model/domain/Currency';

let ProductPricingRestServiceConfig: IRestfulConfigMap = {
    productPricingRestService: {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            list: {
                method: "get",
                path: "api/products/:productId/pricing/list",
                testPath: "api/products/:productId/pricing/list",
                paramDefaults: {
                    "productId": "@productId",
                },
                needCurrency: true

            },
            listPost: {
                method: "post",
                path: "api/v2/products/:productId/pricing/list",
                testPath: "api/v2/products/:productId/pricing/list",
                needCurrency: true,
                paramDefaults: {
                    "productId": "@productId",
                    'versionedAttributeId': "@versionedAttributeId"
                }
            },
            matrix: {
                method: "post",
                path: "api/products/:productId/pricing/matrix",
                testPath: "api/products/:productId/pricing/matrix",
                paramDefaults: {
                    "productId": "@productId"
                }
            },
            specificList: {
                method: "get",
                path: "api/products/:productId/pricing/list",
                testPath: "api/products/:productId/pricing/list",
                paramDefaults: {
                    "productId": "@productId"
                },
                needCurrency: true
            },
            specificMatrix: {
                method: "post",
                path: "api/products/:productId/pricing/matrix",
                testPath: "api/products/:productId/pricing/matrix",
                paramDefaults: {
                    "productId": "@productId"
                },
                requestConfig: {
                    headers: {
                        'saleRegions-country': "US"
                    }
                }
            },
            ProductInstanceProjectName: {
                method: "get",
                path: "api/productInstances/productInstance/:productId/en/latest",
                testPath: "api/productInstances/productInstance/:productId/en/latest",
                paramDefaults: {
                    "productId": "@productId"
                }
            },
            getProjectName: {
                method: "get",
                path: "api/productInstace/:productInstanceId/name",
                testPath: "api/productInstace/:productInstanceId/name",
                paramDefaults: {
                    "productInstanceId": "@productInstanceId"
                }
            },
            productData: {
                method: "get",
                path: "api/products/available/:productId/v2",
                testPath: "api/products/available/:productId/v2",
                paramDefaults: {
                    "productId": "@productId"
                }
            },
            listGet: {
                method: "get",
                path: "api/v2/products/:productId/pricing/list",
                testPath: "api/v2/products/:productId/pricing/list",
                paramDefaults: {
                    "productId": "@productId",
                    "currencyCode": "@currencyCode",
                    'versionedAttributeId': "@versionedAttributeId",
                    "formId": "@formId",
                    "designMethod": "@designMethod"
                }
            },
            // 新-获取网站whiteLabel产品数量价格表（storeCurrency-VersionedAttribute）

            getListByStoreByVersionedAttr: {
                method: "get",
                path: "api/store/whiteLabelProduct/:productId/versioned/:versionedAttributeId/pricing/list/v4",
                testPath: "api/store/whiteLabelProduct/:productId/versioned/:versionedAttributeId/pricing/list/v4",
                paramDefaults: {
                    "productId": "@productId",
                    'versionedAttributeId': "@versionedAttributeId",
                    "designMethod": "@designMethod",
                    "productInstanceId": "@productInstanceId",
                    "propertyModelId": "@propertyModelId"
                }
            },
            // 新-获取网站whiteLabel产品数量价格表（storeCurrency）
            getListByStore: {
                method: "get",
                path: "api/store/whiteLabelProduct/:productId/pricing/list/v4",
                testPath: "api/store/whiteLabelProduct/:productId/pricing/list/v4",
                paramDefaults: {
                    "productId": "@productId",
                    "designMethod": "@designMethod",
                    "productInstanceId": "@productInstanceId",
                    "propertyModelId": "@propertyModelId"
                }
            },

            // 新-获取网站whiteLabel产品单价（storeCurrency-VersionedAttr）
            getPriceByStoreByVersionedAttr: {
                method: "get",
                path: "api/store/whiteLabelProduct/:productId/versioned/:versionedAttributeId/pricing/qty/:qty/v3",
                testPath: "api/store/whiteLabelProduct/:productId/versioned/:versionedAttributeId/pricing/qty/:qty/v3",
                paramDefaults: {
                    "productId": "@productId",
                    "versionedAttributeId": "@versionedAttributeId",
                    "qty": "@qty",
                    "designMethod": "@designMethod"
                }
            },
            // 新-获取网站whiteLabel产品单价（storeCurrency）
            getPriceByStore: {
                method: "get",
                path: "api/store/whiteLabelProduct/:productId/pricing/qty/:qty/v3",
                testPath: "api/store/whiteLabelProduct/:productId/pricing/qty/:qty/v3",
                paramDefaults: {
                    "productId": "@productId",
                    "qty": "@qty",
                    "designMethod": "@designMethod"
                }
            },
            // 随机卡产品计价（随机规则）
            getPriceByRandomRule: {
                method: "post",
                path: "api/productInstance/:id/pricing/list",
                testPath: "api/productInstance/:id/pricing/list",
                paramDefaults: {
                    "id": "@id"
                },
                needCurrency: true
            },
            // 通过属性键值对获取离散计价表
            getDiscretePriceByAttrs: {
                method: "post",
                path: "api/products/:productId/pricing/discrete",
                testPath: "api/products/:productId/pricing/discrete",
                paramDefaults: {
                    "productId": "@productId",
                    "versionedAttributeId":"@versionedAttributeId"
                },
                needCurrency: true
            },
            // 通过店铺产品关联的whiteLabelProductId，获取离散计价表
            getDiscretePriceByStore: {
                method: "post",
                path: "api/store/whiteLabelProduct/:productId/pricing/discrete",
                testPath: "api/store/whiteLabelProduct/:productId/pricing/discrete",
                paramDefaults: {
                    "productId": "@productId",
                    "versionedAttributeId":"@versionedAttributeId"
                }
            },
            // 获取指定产品的计价方式
            getPriceFeatureInfo: {
                method: "get",
                path: "api/products/:productId/priceTable/featureInfo",
                testPath: "api/products/:productId/priceTable/featureInfo",
                paramDefaults: {
                    "productId": "@productId",
                    "versionedAttributeId":"@versionedAttributeId"
                }
            }
        }
    }
}


export { ProductPricingRestServiceConfig };